import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { FIRM, PRACTICE_AREAS } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-nw-navy-dark text-white/90">
      {/* Main */}
      <div className="container-nw py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="bg-white/95 inline-block p-3 rounded-sm">
            <img
              src={FIRM.logo}
              alt="Newberry Wieters"
              className="h-16 w-auto"
            />
          </div>
          <p className="mt-6 text-white/70 text-sm leading-relaxed max-w-md">
            Newberry Wieters is a Charleston-based litigation boutique focused
            on construction disputes, insurance coverage, and complex commercial
            matters throughout South Carolina.
          </p>
          <div className="mt-6 flex items-start gap-3 text-sm text-white/80">
            <MapPin className="w-4 h-4 text-nw-gold mt-1 flex-shrink-0" />
            <div>
              <div>{FIRM.address.street}</div>
              <div>
                {FIRM.address.city}, {FIRM.address.state} {FIRM.address.zip}
              </div>
            </div>
          </div>
          <div className="mt-3 flex items-center gap-3 text-sm text-white/80">
            <Phone className="w-4 h-4 text-nw-gold" />
            <a href={`tel:${FIRM.phone}`} className="hover:text-nw-gold">
              {FIRM.phone}
            </a>
          </div>
          <div className="mt-2 flex items-center gap-3 text-sm text-white/80">
            <Mail className="w-4 h-4 text-nw-gold" />
            <a href={`mailto:${FIRM.email}`} className="hover:text-nw-gold">
              {FIRM.email}
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-white mb-5">
            The Firm
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/about" className="text-white/70 hover:text-nw-gold link-underline">
                About
              </Link>
            </li>
            <li>
              <Link to="/attorneys" className="text-white/70 hover:text-nw-gold link-underline">
                Attorneys
              </Link>
            </li>
            <li>
              <Link to="/practice-areas" className="text-white/70 hover:text-nw-gold link-underline">
                Practice Areas
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-white/70 hover:text-nw-gold link-underline">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-white mb-5">
            Practice Areas
          </h4>
          <ul className="space-y-2.5 text-sm">
            {PRACTICE_AREAS.slice(0, 7).map((p) => (
              <li key={p.slug}>
                <Link
                  to={`/practice-areas#${p.slug}`}
                  className="text-white/70 hover:text-nw-gold link-underline"
                >
                  {p.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-nw py-8 text-xs text-white/60 leading-relaxed">
          <p className="max-w-4xl">
            <span className="font-semibold text-white/80">Disclaimer:</span>{" "}
            This site is for informational purposes only. Past success does
            not indicate the likelihood of success in any future legal
            representation.
          </p>
          <div className="mt-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-white/50">
            <div>
              © {new Date().getFullYear()} Newberry Wieters Law Firm. All rights reserved.
            </div>
            <div className="flex items-center gap-6">
              <span className="hover:text-nw-gold cursor-pointer">Privacy Policy</span>
              <span className="hover:text-nw-gold cursor-pointer">Disclaimer</span>
              <span className="hover:text-nw-gold cursor-pointer">Attorney Advertising</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
